export const width = 100;
export const height = 100;
export default __webpack_public_path__ + "static/icon-agents.e3246997.svg";